import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import QuestionContainer from './QuestionContainer';

const Q9 = ({ history }) => {
  const { t } = useTranslation();
  const Q9Options = useMemo(
    () => [
      {
        id: 0,
        name: t('frequently'),
        value: 'frequently',
      },
      {
        id: 1,
        name: t('time_to_time'),
        value: 'time_to_time',
      },
      {
        id: 2,
        name: t('rarely'),
        value: 'rarely',
      },
      {
        id: 3,
        name: t('never'),
        value: 'never',
      },
    ],
    [t]
  );

  return (
    <QuestionContainer
      history={history}
      title={t('question9')}
      options={Q9Options}
      nextUrl="q10"
      screenName="q9"
    />
  );
};

export default Q9;
